export { default } from './withLabel';
